import * as headerBlock from '../header/';
import * as personalDetails from './personalDetails/';

export default {
  name: 'add-user',
  props: [
    'onLogout',
    'type',
  ],
  components: { headerBlock, personalDetails },
  mounted() {

  },
  data() {
    return {
      breadCrumbItems: [
        {
          text: 'Home',
          to: `${process.env.START_URL}/`,
        }, {
          text: 'Users & Permissions',
          routerName: 'User & Permissions',
        }, {
          text: 'Add administrator',
          active: true,
        },
      ],
    };
  },
  methods: {
    bradcrumbClick(e) {
      if (!e.routerName) return;
      this.$router.push({ name: 'User & Permissions', params: { type: this.type } });
    },
  },
  computed: {

  },
  created() {
    let breadActionType = (this.$route.params.userId) ? 'Change' : 'Add';
    let breadUserType = (this.type == 'admin') ? 'administrator' : 'user';
    this.breadCrumbItems[this.breadCrumbItems.length - 1].text =
      `${breadActionType} ${breadUserType}`;
    const token = localStorage.getItem('access_token');
    const authUser = localStorage.getItem('authUser');
    this.access_token = token || '';
    this.authUser = authUser ? JSON.parse(authUser) : null;
  },
};




// WEBPACK FOOTER //
// ./src/components/addUser/addUser.component.js